import { MutationCache, QueryCache } from '@tanstack/react-query';

import { isApiAuthError, reportGlobalApiError } from '../helpers/api-errors';

export const QueryClientConfig = {
  // Surface permission (403) and session-expiry (401) errors as a single toast no
  // matter which query or mutation hit them — including loaders and any hook that
  // doesn't wire its own onError. reportGlobalApiError ignores everything else, so
  // ordinary errors stay with each hook's existing handler.
  queryCache: new QueryCache({ onError: reportGlobalApiError }),
  mutationCache: new MutationCache({ onError: reportGlobalApiError }),
  defaultOptions: {
    queries: {
      // Show cached data immediately if available
      placeholderData: (previousData: unknown) => previousData,
      refetchOnMount: true,
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      // Retrying a permission/session failure just replays the same rejection,
      // so fail fast on those and keep the two-retry budget for transient errors.
      retry: (failureCount: number, error: Error) => !isApiAuthError(error) && failureCount < 2,
    },
  },
};

export const QUERY_CLIENT_MAX_AGE = 3 * 24 * 60 * 60 * 1000; // 3 days max age
